import { some } from 'lodash';
import { useState } from 'react';
import { FormStep, Package, StepType, StepTypeWithIndex } from '../../types';
import { StepNavigator } from './StepNavigator';
import { usePreviousStep } from './usePreviousStep';
import { useStepHistory } from './useStepHistory';

export const useStepNavigation = (
  rateCode: string,
  packageData: Package | undefined,
  allFormSteps: FormStep[]
) => {
  const [currentStep, setCurrentStep] = useState<StepTypeWithIndex>({
    type: 'rooms',
    index: 0,
    step: 'guestDetailsStep',
  });
  const steps: StepType[] = ['rooms'];
  if (some(packageData?.experiences)) {
    steps.push('spa');
  }
  if (some(packageData?.restaurants)) {
    steps.push('dining');
  }

  useStepHistory(currentStep, setCurrentStep, allFormSteps);

  const isLastStep = currentStep.index === allFormSteps.length - 1;

  const currentFormStep = allFormSteps[currentStep.index] || allFormSteps[0];

  const goToNextStep = () => {
    setCurrentStep((val) => {
      const nextStep = allFormSteps[val.index + 1];
      return nextStep
        ? { type: nextStep.type as StepType, index: val.index + 1, step: nextStep.step }
        : {
            type: 'rooms',
            index: 0,
            step: 'guestDetailsStep',
          };
    });
  };

  const goToPreviousStep = usePreviousStep(rateCode, currentStep);

  return {
    stepNavigatorComponent: StepNavigator(rateCode, currentStep, steps),
    goToNextStep,
    goToPreviousStep,
    isLastStep,
    currentFormStep,
    currentStepIndex: currentStep.index,
  };
};
